// extracted by css-extract-rspack-plugin
export default {"moreButton":"more-button__moreButton___rYOm5 common__secondaryButton___jY9uZ common__button___UCWIz common__bold___ve4Qa"};